import { render, staticRenderFns } from "./NR1Distribution.vue?vue&type=template&id=34b503bf&scoped=true&"
import script from "./NR1Distribution.vue?vue&type=script&lang=js&"
export * from "./NR1Distribution.vue?vue&type=script&lang=js&"
import style0 from "./NR1Distribution.vue?vue&type=style&index=0&id=34b503bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b503bf",
  null
  
)

export default component.exports